document.addEventListener('DOMContentLoaded', () => {
    const storeName = document.querySelector('[store-name]')?.getAttribute('store-name');


    if(storeName !== 'rslt'){
        return
    }

    const bigImage = document.querySelector('.product-images--big-image .product-images__slide:first-child img');


    const updatedThumbnails = document.querySelectorAll('.product-thumbnail img');
    updatedThumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {

            const productImagesSlidesAll = document.querySelectorAll('.product-images__slide');
            productImagesSlidesAll.forEach((productImagesSlide) => {
                productImagesSlide.classList.remove('is-active-slide');
            });

            const productSlide = thumbnail.closest('.product-images__slide');
            productSlide.classList.add('is-active-slide');

            bigImage.src = thumbnail.src;
            bigImage.srcset = thumbnail.srcset || '';
            bigImage.alt = thumbnail.alt;
            
        });
    });
});
